import { atom } from "jotai";

export const activePageAtom = atom("homepage");
export const showSearchModal = atom(false);
